<p>manage-devices works!</p>
